import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useState } from "react";
import { useRetrievePlayerByUserId, useRetrieveTeamsByPlayerId, } from "./ApiProvider";
import Landing from "./Landing";
import { useRetrieveLeaguesByPlayerId } from "./api/LeagueApiProvider";
import { UserContext } from "./auth/UserProvider";
import { ErrorView } from "./nav/Error";
import { Loading } from "./nav/Loading";
import { HomeHub } from "./onboarding/HomeHub";
import { ProfileSetup } from "./onboarding/ProfileSetup";
import { dismissOnboarding, isOnboardingDismissed, } from "./onboarding/onboardingDismissal";
import { playerDisplayName } from "./players/PlayerDisplayNameLink";
import { PlayerPage } from "./players/PlayerPage";
const Home = () => {
    const { user: contextUser, loading: isContextUserLoading } = useContext(UserContext);
    const { isLoading: isPlayerLoading, error: playerError, data: player, } = useRetrievePlayerByUserId({ userId: contextUser?.pk });
    const { data: teams = [], isLoading: isTeamsLoading } = useRetrieveTeamsByPlayerId({ playerId: player?.id });
    const { data: leagues = [], isLoading: isLeaguesLoading } = useRetrieveLeaguesByPlayerId({ playerId: player?.id });
    const [dismissed, setDismissed] = useState(false);
    const [hubDismissed, setHubDismissed] = useState(false);
    const loading = isPlayerLoading ||
        isContextUserLoading ||
        isTeamsLoading ||
        isLeaguesLoading;
    if (!contextUser && !isContextUserLoading) {
        return _jsx(Landing, {});
    }
    if (loading) {
        return _jsx(Loading, {});
    }
    if (!player || playerError) {
        return _jsx(ErrorView, { error: new Error("Player not found") });
    }
    const isNewUser = teams.length === 0 && leagues.length === 0;
    const userPk = contextUser?.pk;
    const profileSetupSeen = dismissed || (userPk !== undefined && isOnboardingDismissed(userPk));
    // First run: a brand-new user (no teams, no leagues) who hasn't been through
    // profile setup sees the standard player form behind a welcome. Save/Skip both
    // mark it seen and fall through to the Home hub.
    if (isNewUser && userPk !== undefined && !profileSetupSeen) {
        return (_jsx(ProfileSetup, { player: player, onDone: () => {
                dismissOnboarding(userPk);
                setDismissed(true);
            } }));
    }
    // Still nothing to show a feed for: offer the three first-run paths, unless
    // the user skipped the hub to look around (they can re-open it from the feed).
    if (isNewUser && !hubDismissed) {
        return (_jsx(HomeHub, { firstName: playerDisplayName(player).split(" ")[0], onSkip: () => setHubDismissed(true) }));
    }
    return (_jsx(PlayerPage, { player: player, canViewTeams: true, canModify: true, onGetStarted: isNewUser ? () => setHubDismissed(false) : undefined }));
};
export default Home;
